import { useEffect, useState } from "react";

import {
  readCskPreviewFromLocation,
  type CskPreviewMode,
} from "src/utils/csk-preview";

/**
 * Active `?csk=` / `?preview=` mode. Null on SSR and the first client render;
 * the URL is read after mount so Suspense can finish hydrating first.
 */
export function useCskPreviewMode(): CskPreviewMode | null {
  const [mode, setMode] = useState<CskPreviewMode | null>(null);

  useEffect(() => {
    const apply = () => setMode(readCskPreviewFromLocation());
    apply();
    window.addEventListener("popstate", apply);
    return () => window.removeEventListener("popstate", apply);
  }, []);

  return mode;
}
